import { useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import config from "config"
import { useQuery } from "@tanstack/react-query"
import { isSignInRequired, signInAgain } from "auth/sessionEnded"

const useAccessToken = (): string => {
    const { getAccessTokenSilently, loginWithRedirect } = useAuth0()

    const { data: token = "", error } = useQuery({
        queryKey: ["auth0-access-token"],
        queryFn: async () => {
            const accessToken = await getAccessTokenSilently({
                authorizationParams: {
                    audience: config.auth0Audience,
                },
            })
            console.log("Auth0 token obtained!")
            return accessToken
        },
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: false,
    })

    // Sign in again when only that helps (no Auth0 session / nothing to renew
    // with), or when there is no token at all. A transient failure while a
    // token is held (a timed-out renewal shared through the SDK's one in-flight
    // token call) keeps the token: its requests fail on their own if it has
    // really expired.
    useEffect(() => {
        if (error && (!token || isSignInRequired(error))) {
            console.log("Token acquisition error: ", (error as any).message)
            signInAgain(loginWithRedirect)
        }
    }, [error, token, loginWithRedirect])

    return token
}

export default useAccessToken
